import { render, staticRenderFns } from "./DownloadProfile.vue?vue&type=template&id=2006a4fa&scoped=true"
import script from "./DownloadProfile.vue?vue&type=script&lang=js"
export * from "./DownloadProfile.vue?vue&type=script&lang=js"
import style0 from "./DownloadProfile.vue?vue&type=style&index=0&id=2006a4fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006a4fa",
  null
  
)

export default component.exports